import styled from "styled-components";

export const SeeAllImagesButton = styled.button`
  color: var(--primary-blue);
  outline: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: var(--fs-base);
  font-weight: 600;

  &:hover {
  }
`;
